<template>
    <popup :opened="dataToShow" @close="close">

        <!-- BEGIN Content modal add referent -->
        <div v-if="dataToShow">
            <div class="my-5 mx-5 md:my-15 md:mx-10 2xl:my-20 2xl:mx-15">
                <h3 v-if="proToEdit === null" class="mb-10">Ajouter une nouvelle expérience professionnelle</h3>
                <h3 v-if="proToEdit" class="mb-10">Modifier l'expérience professionnelle</h3>
                <div class="grid grid-cols-4 gap-5 items-center">
                    <input-text
                        :error="true"
                        :maxlength="40"
                        :value="newPro.intitule_parcours"
                        class="md:col-span-2"
                        libelle="Poste occupé"
                        name="intitule_parcours"
                        @input="(newValue) => {newPro.intitule_parcours = newValue}"
                    />
                    <date-picker
                        :value="newPro.debut_parcours"
                        class="col-span-full md:col-span-1"
                        format="dd/MM/yyyy"
                        initialview="year"
                        libelle="Début"
                        name="debut_parcours"
                        @input="(newValue) => {newPro.debut_parcours = newValue}"
                    />
                    <date-picker
                        :value="newPro.fin_parcours"
                        class="col-span-full md:col-span-1"
                        format="dd/MM/yyyy"
                        initialview="year"
                        libelle="Fin"
                        name="fin_parcours"
                        @input="(newValue) => {newPro.fin_parcours = newValue}"
                    />
                    <input-text
                        :error="true"
                        :value="newPro.structure_accueil_parcours"
                        class="md:col-span-2"
                        libelle="Nom de la structure d'accueil"
                        name="structure_accueil_parcours"
                        @input="(newValue) => {newPro.structure_accueil_parcours = newValue}"
                    />
                    <input-text
                        :error="true"
                        :value="newPro.localisation_parcours"
                        class="md:col-span-2"
                        libelle="Ville"
                        name="localisation_parcours"
                        @input="(newValue) => {newPro.localisation_parcours = newValue}"
                    />
                    <input-text-area
                        :error="true"
                        :value="newPro.aborde_parcours"
                        class="md:col-span-full"
                        libelle="Les activités et tâches principales qui vous ont été confiées"
                        name="aborde_parcours"
                        @input="(newValue) => {newPro.aborde_parcours = newValue}"
                    />
                </div>

                <div class="flex justify-center mt-15">
                    <action-button
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-pink-600"
                        bg-color-square="bg-pink-600"
                        icon-color="text-white"
                        libelle="ENREGISTRER"
                        type-shadow="shadow-pink"
                        @clickAction="(proToEdit) ? modifyPro() : addPro()"
                    />
                </div>

            </div>
        </div>
    </popup>
</template>

<script>
import Popup from '../../../components/Popup.vue';
import Icon from  '../../../components/Icon.vue';
import InputText from '../../../components/Inputs/InputText.vue';
import InputSelect from '../../../components/Inputs/InputSelect.vue';
import DatePicker from '../../../components/Inputs/DatePicker.vue';
import ActionButton from '../../../components/ActionButton.vue';
import InputTextArea from '../../../components/Inputs/InputTextArea.vue';

export default {
  components:{
    Popup,
    Icon,
    InputText,
    InputSelect,
    DatePicker,
    ActionButton,
    InputTextArea,
  },

  props:{
    dataToShow:{
      type: Boolean,
      required: false,
      default: false
    },
    proToEdit:{
      type: Object,
      required: false,
      default: null
    }
  },

  data(){
    return {
      newPro:{
        intitule_parcours:'',
        debut_parcours:'',
        fin_parcours:'',
        localisation_parcours:'',
        structure_accueil_parcours:'',
        aborde_parcours:'',
      },
    };
  },

  methods:{
    close(){
      this.$emit('close');
    },

    addPro(){
      this.$emit('addPro', this.newPro);
      this.close(false);
      this.newPro = {
        intitule_parcours:'',
        debut_parcours:'',
        fin_parcours:'',
        localisation_parcours:'',
        structure_accueil_parcours:'',
        aborde_parcours:'',
      };
    },

    modifyPro(){
      this.$emit('modifyPro', this.newPro);
      this.close(false);
      this.newPro = {
        intitule_parcours:'',
        debut_parcours:'',
        fin_parcours:'',
        localisation_parcours:'',
        structure_accueil_parcours:'',
        aborde_parcours:'',
      };
    },
  },
  watch:{
    dataToShow:{
      handler(){
        if(this.proToEdit){
          this.newPro = this.proToEdit.value.value;
          return;
        }
        this.newPro = {
          intitule_parcours:'',
          debut_parcours:'',
          fin_parcours:'',
          localisation_parcours:'',
          structure_accueil_parcours:'',
          aborde_parcours:'',
        };
      },
    },
  }
};
</script>
